import React from "react";
import Plot from "react-plotly.js";
import { Container, Row, Col, Card, Button } from "react-bootstrap";

import { downloadCSV } from "../utils/downloadCSV";


function AnalysisChart({ budget, actualCost, forecast, chartType, months_present, months_future }) {

    // SAFE DEFAULTS
    budget = budget || [];
    actualCost = actualCost || [];
    forecast = forecast || [];
    months_present = months_present || [];
    months_future = months_future || [];

    if (budget.length === 0 && actualCost.length === 0) {
        return <p>Nessun dato disponibile</p>;
    }

    // =========================
    // 🔵 MAIN CHART
    // =========================

    const categories = budget.map(row => row.category);

    const costValues = budget.map(row => {
        const costRow = actualCost.find(r => r.category === row.category);
        return costRow ? (costRow.TOTAL ?? 0) : 0;
    });

    const budgetPast = budget.map(row =>
        months_present.reduce((sum, m) => sum + (row[m] ?? 0), 0)
    );

    const budgetFuture = budget.map(row =>
        months_future.reduce((sum, m) => sum + (row[m] ?? 0), 0)
    );

    // CSV MAIN
    const csvMain = categories.map((cat, i) => ({
        Categoria: cat,
        Cost: costValues[i],
        Budget_YTD: budgetPast[i],
        Budget_Remaining: budgetFuture[i]
    }));

    const dataMain = [
        {
            x: categories,
            y: costValues,
            type: "bar",
            name: "Cost",
            marker: { color: "blue" },
            offsetgroup: "cost"
        },
        {
            x: categories,
            y: budgetPast,
            type: "bar",
            name: "Budget (YTD)",
            marker: { color: "orange" },
            offsetgroup: "budget"
        },
        {
            x: categories,
            y: budgetFuture,
            type: "bar",
            name: "Budget (Remaining)",
            marker: { color: "darkgreen" },
            offsetgroup: "budget",
            base: budgetPast
        }
    ];

    const layoutMain = {
        width: 1000,
        height: 750,
        title: { text: `Totale per <b>${chartType}</b>`, x: 0.5 },
        xaxis: {
            tickangle: -50,
            automargin: true
        },
        yaxis: {
            title: {
                text: "Totale Q.ta consuntivo [h]",
                standoff: 20
            },
            tickformat: ",d", 
            automargin: true
        },
        barmode: "group",
        margin: { t: 80, b: 150, l: 80, r: 40 }
    };

    // =========================
    // MAIN CHARTS
    // =========================

    const months = [...months_present, ...months_future];

    const categoryCharts = budget.map((row) => {

        const category = row.category;
        const costRow = actualCost.find(r => r.category === category) || {};

        const costValuesMonth = months.map(m =>
            months_present.includes(m) ? (costRow[m] ?? 0) : 0
        );

        const budgetValuesMonth = months.map(m => row[m] ?? 0);

        // CSV categoria
        const csvData = months.map((m, i) => ({
            Mese: m,
            Cost: costValuesMonth[i],
            Budget: budgetValuesMonth[i]
        }));

        return (
            <Col md={12} key={category} className="mb-4">
                <Card>
                    <Card.Header className="bg-primary text-white">
                        {category}
                    </Card.Header>
                    <Card.Body>

                        <Button
                            className="mb-3"
                            onClick={() => downloadCSV(`${category}.csv`, csvData)}
                        >
                            Scarica CSV
                        </Button>

                        <Plot
                            data={[
                                {
                                    x: months,
                                    y: costValuesMonth,
                                    type: "bar",
                                    name: "Cost",
                                    marker: { color: "blue" }
                                },
                                {
                                    x: months,
                                    y: budgetValuesMonth,
                                    type: "bar",
                                    name: "Budget",
                                    marker: { color: "orange" }
                                }
                            ]}
                            layout={{
                                height: 500,
                                title: `${category}`,
                                xaxis: {
                                    title: "Mese",
                                    tickangle: -45,
                                    automargin: true
                                },
                                yaxis: { 
                                    title: { 
                                        text: "Totale [h]", standoff: 20 
                                    }, 
                                    tickformat: ",d" 
                                },
                                barmode: "group",
                                margin: { t: 50, b: 120, l: 60, r: 30 },

                                shapes: [
                                    {
                                        type: "rect",
                                        x0: months_present.length - 0.5,
                                        x1: months.length - 0.5,
                                        y0: 0,
                                        y1: 1,
                                        yref: "paper",
                                        fillcolor: "rgba(3, 44, 3, 0.08)",
                                        line: { width: 0 }
                                    }
                                ]
                            }}
                            style={{ width: "100%" }}
                        />

                    </Card.Body>
                </Card>
            </Col>
        );
    });

    // =========================
    // RENDER
    // =========================

    return (
        <Container fluid>

            {/* CSV MAIN */}
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
                <Button onClick={() => downloadCSV(`Totale_${chartType}.csv`, csvMain)}>
                    Scarica CSV Sommario
                </Button>
            </div>

            <Plot data={dataMain} layout={layoutMain} style={{ marginBottom: "40px" }} />

            <Row>{categoryCharts}</Row>

        </Container>
    );
}

export default AnalysisChart;